/*
 * @Author: your name
 * @Date: 2020-05-26 19:40:04
 * @LastEditTime: 2020-06-10 17:19:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \client-v4\src\api\info.js
 */
/**
 * auth模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../request/http'; // 导入http中创建的axios实例
import store from '../store';

const info = {
    //买家信息
    getuserInfo() {
        return axios.get(base.dev + '/acheteur');
    },
    //买家信息
    getInfo() {
        return axios.get(base.dev + '/acheteur/informations');
    },
    //修改信息
    update(obj) {
        return axios.post(base.dev + '/v2/acheteurs/account/save', obj, {
            headers: {'Content-Type': 'multipart/form-data'}
        });
    },
    //修改信息,没有上传文件就不用multipart
    updateInfo(obj) {
        return axios.post(base.dev + '/v2/acheteurs/account/save', obj);
    },
    //地址
    getAddress(id) {
        return axios.get(base.dev + `/acheteur/${id}/adresse`);
    },
    //创建地址接口
    addAddress(obj) {
        return axios.post(base.dev + `/acheteur/${obj.id_acheteur}/adresse`, obj);
    },
    //删除地址
    deleAddress(obj) {
        return axios.delete(base.dev + `/acheteur/${obj.id_acheteur}/adresse/${obj.id_adresse}`);
    },
    //物流信息
    getDelivary(obj) {
        return axios.get(base.dev + `/acheteur/${obj.id}/livraisons`);
    },
    //获取物流报价
    getDelivaryPrice(obj) {
        return axios.get(base.dev + `/v2/adresses/${obj.id_adresse}/livraisons`);
    },
    //添加物流信息
    addDelivary(obj) {
        return axios.post(base.dev + `/acheteur/${obj.id_acheteur}/livraisons`, obj);
    },
    //营业范围
    fetchActivites(obj) {
        return axios.get(base.dev + `/activites`, {params: obj});
    },
    //删除物流
    deleteDelivary(obj) {
        return axios.delete(base.dev + `/acheteur/${obj.id_acheteur}/livraisons/${obj.id_livraison}`);
    },
    //订单
    orderList(obj) {
        return axios.post(base.dev + `/v2/commandes/list`, obj,{timeout: 50 * 1000});
    },
    //查找商家
    getvender() {
        return axios.get(base.dev + `/v2/vendeurs/list?marques=china`);
    },
    //获取国家
    getNations() {
        return axios.get(base.dev + '/pays');
    },
    //获取买家订单详情
    getCommnndes(obj, params) {
        return axios.get(base.dev + `/acheteur/${obj.id_ahceteur}/commandes/${obj.id_commande}`, {params});
    },
    //获取买家订单组详情
    get_commandes_groupes(params) {
        return axios.get(base.dev + `/v2/commandes/get_commandes_groupes`, {params});
    },
    //获取用户优惠券 订单或者物流优惠，系统发放的
    getOrderOrDeliverRemiseCode() {
        if (!store.state.token) return new Promise(resolve => {
        });
        return axios.get(base.dev + `/v2/remises/getOrderOrDeliverRemiseCode`);
    },
    //买家信息
    getV2Info() {
        return axios.get(base.dev + '/v2/acheteurs/get_buyer_info');
    },
    //买家发邮件联系管理员
    contactAdmin(body) {
        return axios.post(base.dev + '/v2/acheteurs/contact_admin', body);
    },
    //买家订单问题联系管理员
    order_after_contact_admin(body) {
        return axios.post(base.dev + '/v2/acheteurs/order_after_contact_admin', body, {
            headers: {'Content-Type': 'multipart/form-data'}
        });
    },
}
export default info;
